module.exports = __webpack_public_path__ + "static/media/personas-cover.3e2147d5.jpg";